import React from "react";

const ToolSection = () => {
  const toolContent = [
    {
      tite: "Historical Currency Rates",
      content:
        "Vestibulum ac diam sit amet quam vehicula elemen tum sed sit amet dui praesent sapien pellen tesque .",
    },
    {
      tite: "Travel Expense Calculator",
      content:
        "Vestibulum ac diam sit amet quam vehicula elemen tum sed sit amet dui praesent sapien pellen tesque .",
    },
    {
      tite: "Currency Email Updates",
      content:
        "Vestibulum ac diam sit amet quam vehicula elemen tum sed sit amet dui praesent sapien pellen tesque .",
    },
  ];

  return (
    <div className="tool_section section-padding">
      <div className="container px-sm-1 px-4">
        {/* CONTENT SECTION */}
        <div className="row">
          <div className="col-lg-6 pe-lg-5 mb-lg-1 mb-5">
            <div className="tool_content">
              <p  data-aos='fade-up'  className="text-style text-green mb-4">CUEX CURRENCY TOOLS</p>
              <h2 data-aos='fade-up'  className="text-black fw-700">
                We Provide Currency Exchange Services World Wide
              </h2>
              <p data-aos='fade-up' className="mt-4 mb-5 text-justify-left">
                Best Strategic planning dolor sit amet consectetur adipiscing
                elit. Scel erus isque ametus odio velit auctor nam elit nulla
                eget sodales dui pulvinar dolor strategic planning dolor sit
                sectetur morethe.
              </p>

              {toolContent.map((element, index) => {
                return (
                  <div
                    key={index}
                    className="about_list  mt-4 d-flex   align-items-start"
                    data-aos='fade-up'
                  >
                    <div className="list_img me-4">
                      <i class="fa-solid fa-check"></i>
                    </div>
                    <div className="list_content">
                      <h5 className="fw-700 text-black">{element.tite}</h5>
                      <p className="mt-4 mb-0 text-justify-left">
                        {element.content}
                      </p>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
          {/* IMAGE SECTION */}
          <div className="col-lg-6 ps-lg-5">
            <div className="tool_img position-relative index-1">
                <div className="" data-aos='zoom-in' >
                    <img src="/image/tool-section/tool-shape.png" className="img-fluid tool_animation" alt="" />
                </div>
              <div className="row">
                <div className="col-6">
                  <div className="about_img" data-aos='zoom-in'>
                    <img
                      src="/image/tool-section/img-1.jpg"
                      className="img-fluid rounded-4 mb-4"
                      alt=""
                    />
                  </div>
                </div>
                <div className="col-6">
                  <div className="about_img padding-top" data-aos='zoom-in'>
                    <img
                      src="/image/tool-section/img-2.jpg"
                      className="img-fluid rounded-4 "
                      alt=""
                    />
                    <img
                      src="/image/tool-section/img-3.jpg"
                      className="img-fluid rounded-4 mt-md-5 mt-4"
                      alt=""
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ToolSection;
